import { styled } from 'styled-components';
import { RadioSelectionCard } from '../../RadioSelectionCard';
export const StyledTimeslotCard = styled(RadioSelectionCard).withConfig({
  componentId: "aui__sc-92ehvh-0"
})(["padding:0.75rem 0;line-height:1;"]);
export const TimeContainer = styled.div.withConfig({
  componentId: "aui__sc-92ehvh-1"
})(["display:grid;grid-template-columns:repeat( auto-fit,minmax( min(calc(100% / 1 - 0.5rem),max(10rem,calc(100% / 4 - 0.5rem))),1fr ) );gap:0.5rem;"]);